import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { capitalize } from 'lodash-es';
import { PlatformAccountDeviceDTO } from './platform-account-device.dto';

export enum AccountType {
  TIKTOK = 'tiktok',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  PINTEREST = 'pinterest',
  TWITTER = 'twitter',
  YOUTUBE = 'youtube',
  LINKEDIN = 'linkedin',
  AMAZON = 'amazon',
  PLANOLY = 'planoly',
  THREADS = 'threads'
}

@Exclude()
export class PlatformAccountDTO {
  @Expose()
  id: string;

  @Expose()
  username: string;

  @Expose()
  canonicalUsername: string;

  @Expose()
  pic: string;

  @Expose()
  type: string;

  @Expose()
  enabled: boolean;

  @Expose()
  isActive: boolean;

  @Expose()
  @Type(() => PlatformAccountDeviceDTO)
  platformAccountDevice: PlatformAccountDeviceDTO[];

  @Expose()
  @Transform((value) => (value ? (isNaN(value.value) ? new Date(value.value) : new Date(parseInt(value.value))) : null), {
    toClassOnly: true
  })
  tokenExpirationDate: Date;

  @Expose()
  @Transform((value) => (value ? (isNaN(value.value) ? new Date(value.value) : new Date(parseInt(value.value))) : null), {
    toClassOnly: true
  })
  refreshExpirationDate: Date;

  @Expose()
  isToggledAccount: boolean;

  @Expose()
  accountProfile: string;

  get isInstagram(): boolean {
    return this.type === AccountType.INSTAGRAM;
  }

  get isPinterest(): boolean {
    return this.type === AccountType.PINTEREST;
  }

  get isTiktok(): boolean {
    return this.type === AccountType.TIKTOK;
  }

  get isFacebook(): boolean {
    return this.type === AccountType.FACEBOOK;
  }

  get isTwitter(): boolean {
    return this.type === AccountType.TWITTER;
  }

  get isYoutube(): boolean {
    return this.type === AccountType.YOUTUBE;
  }

  get isLinkedIn(): boolean {
    return this.type === AccountType.LINKEDIN;
  }

  get isAmazon(): boolean {
    return this.type === AccountType.AMAZON;
  }

  get isPlanoly(): boolean {
    return this.type === AccountType.PLANOLY;
  }

  get isThreads(): boolean {
    return this.type === AccountType.THREADS;
  }

  isValidAccount() {
    // The planoly account will always be valid
    if (this.type === AccountType.PLANOLY) {
      return true;
    }
    if (this.type === AccountType.INSTAGRAM || this.type === AccountType.FACEBOOK || this.type === AccountType.TWITTER || this.type === AccountType.THREADS) {
      if (!isNaN(this.tokenExpirationDate?.getTime())) {
        return this.tokenExpirationDate > new Date();
      } else {
        return true;
      }
    } else {
      if (!isNaN(this.refreshExpirationDate?.getTime())) {
        return this.refreshExpirationDate > new Date();
      } else {
        return true;
      }
    }
  }

  get typeDisplayName(): string {
    switch (this.type) {
      case AccountType.TIKTOK:
        return 'TikTok';
      case AccountType.YOUTUBE:
        return 'YouTube';
      case AccountType.LINKEDIN:
        return 'LinkedIn';
      case AccountType.TWITTER:
        return 'X';
      default:
        return capitalize(this.type);
    }
  }
}
